import {AttachedFile} from "../Components/BaseTypes.ts";
import * as React from "react";

export function Attachment({attachment, onDelete, renderInputs = true}:
                               {
                                   renderInputs?: boolean
                                   attachment: AttachedFile,
                                   onDelete: () => void
                               }) {
    return <div className="w-100">
        {!!renderInputs &&
            <>
                <input type={'hidden'}
                       name={`attachments[${attachment.id}][id]`}
                       value={attachment.id}/>
                {/*{attachment.docIds?.map(docId =>*/}
                {/*    <input type={'hidden'}*/}
                {/*           name={`attachments[${attachment.id}][docs][]`}*/}
                {/*           value={docId}/>*/}
                {/*)}*/}
                {/*{attachment.dwgIds?.map(dwgId =>*/}
                {/*    <input type={'hidden'}*/}
                {/*           name={`attachments[${attachment.id}][drawings][]`}*/}
                {/*           value={dwgId}/>*/}
                {/*)}*/}
                <input type={'hidden'}
                       name={`attachments[${attachment.id}][transmittal]`}
                       value={attachment.trnId}/>
                <input type={'hidden'}
                       name={`attachments[${attachment.id}][verifiedFilePath]`}
                       value={attachment.verifiedFilePath}/>
                <input type={'hidden'}
                       name={`attachments[${attachment.id}][attachedFileName]`}
                       value={attachment.attachedFileName}/>
                <input type={'hidden'}
                       name={`attachments[${attachment.id}][attachedFileSize]`}
                       value={attachment.attachedFileSize}/>
                <input type={'hidden'}
                       name={`attachments[${attachment.id}][attachedFileChecksum]`}
                       value={attachment.attachedFileChecksum}/>
                <input type={'hidden'}
                       name={`attachments[${attachment.id}][filePathVerificationAttempted]`}
                       value={attachment.isFilePathVerificationAttempted ? 1 : 0}/>
            </>
        }

        {!!attachment.attachedFileName &&
            <div className="w-100 d-flex justify-content-between align-items-center">
                <div className="small d-flex align-items-center">
                    <span onClick={() => {
                        onDelete()
                    }}
                          style={{backgroundSize: '0.6rem', cursor: 'pointer'}}
                          className='btn btn-close small'>
                    </span>
                    {attachment.isSaved ?
                        <a title={attachment.verifiedFilePath} target="_blank"
                           href={`/document/attachment/${attachment.id}/openFile`}>{attachment.attachedFileName}</a>
                        :
                        <span title={attachment.verifiedFilePath}
                              style={{whiteSpace: 'nowrap'}}>{attachment.attachedFileName}
                        </span>
                    }

                </div>
                <span className='text-body-secondary small text-nowrap'>{(Number(attachment.attachedFileSize)/1024/1024).toFixed(2)} MB</span>
            </div>
        }

        {!attachment.isFilePathVerificationAttempted && attachment.attachedFileName &&
            <span
                className="small text-body-secondary">(Awaiting verification of location in Project Folder)</span>}

        {attachment.isFilePathVerificationAttempted &&
            !attachment.isCurrentVerifiedFilePathValid &&
            attachment.attachedFileName &&
            <span className="small bg-warning">
                                    Attached file could not be found in Project Folder, please ensure validity and then try to attach again
                                </span>}

    </div>
}
